import { render, staticRenderFns } from "./PhotoDeliveryGuide.vue?vue&type=template&id=2336769e&scoped=true"
import script from "./PhotoDeliveryGuide.vue?vue&type=script&lang=js"
export * from "./PhotoDeliveryGuide.vue?vue&type=script&lang=js"
import style0 from "./PhotoDeliveryGuide.vue?vue&type=style&index=0&id=2336769e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336769e",
  null
  
)

export default component.exports